var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlMaskOutlined = function SvgHtlMaskOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.762 10.543a.505.505 0 0 1-.064-.054L1.84 8.632a2.824 2.824 0 0 1-.57-3.215 2.822 2.822 0 0 1 2.8-1.643h7.859a2.822 2.822 0 0 1 2.8 1.643 2.823 2.823 0 0 1-.571 3.215l-1.857 1.857a7.87 7.87 0 0 1-4.3 1.743 7.881 7.881 0 0 1-4.239-1.689Zm.79-.662a6.63 6.63 0 0 0 3.449 1.351 6.63 6.63 0 0 0 3.448-1.354V4.772h-6.9l.003 5.11ZM2.179 5.838a1.813 1.813 0 0 0 .37 2.087l1 1V4.783A1.824 1.824 0 0 0 2.178 5.84h.001Zm10.27 3.09 1-1a1.814 1.814 0 0 0 .37-2.087 1.824 1.824 0 0 0-1.373-1.052l.003 4.14ZM7 9.765a.5.5 0 1 1 0-1h2a.5.5 0 0 1 0 1H7Zm0-2.327a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1H7Z"
  })));
};
export default SvgHtlMaskOutlined;